<template>
  <div class="col-md-3 mb-4">
    <div class="large-card">
      <div class="img-wrapper single-pic">
        <a href="#" class="img-position">
          <div class="img-prev">
            <img :src="getImage(amount,type)" alt="" />
          </div>
        </a>
      </div>
      <div class="content-wrapper">
        <div class="textBlock">
          <h5>Days : {{ days }}</h5>
          <h5>Rarity : {{ getRarity(amount,type) }}</h5>
          <h5>Stake Amount : {{ amount }}</h5>
        </div>
        <div class="content">
          <div class="buttons px-3">
            <a href="#">
              <button
                type="button"
                class="btn btn-stake btn-block w-100"
                @click.prevent="stake(days, amount, type)"
              >
                Stake
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../services";
import "vue-loading-overlay/dist/vue-loading.css";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "Shipyard",
  props: ["error", "days", "amount", "type","rarity"],
  showModal: true,
  data() {
    return {
      info: null,
      isLoading: false,
      isImageLoaded: false,
      icon: "captain.jpeg",
      isSelected: false,
    };
  },
  mounted() {},
  methods: {
    getRarity(amount,type){
        if(type=="ship"){
            if(amount==10000)return "Cog";
            else if(amount==30000)return "Caravel";
            else if(amount==90000)return "Carrack";
            else if(amount==270000)return "Galleon";
            else if(amount==15000)return "Cog";
            else if(amount==45000)return "Caravel";
            else if(amount==135000)return "Carrack";
            else if(amount==400000)return "Galleon";
        }else{
            if(amount==15000)return "Lad";
            else if(amount==45000)return "Landlubber";
            else if(amount==135000)return "Old Salt";
            else if(amount==400000)return "Seadog";
            else if(amount==10000)return "Lad";
            else if(amount==30000)return "Landlubber";
            else if(amount==90000)return "Old Salt";
            else if(amount==270000)return "Seadog";
        }
    },
    loaded() {
      this.isImageLoaded = true;
    },
    getImage(amount,type) {
      if(type=="ship"){
            if(amount==10000)return "images/template/cog.png";
            else if(amount==30000)return "images/template/caravel.png";
            else if(amount==90000)return "images/template/carrack.png";
            else if(amount==270000)return "images/template/galleon.png";
            else if(amount==15000)return "images/template/cog.png";
            else if(amount==45000)return "images/template/caravel.png";
            else if(amount==135000)return "images/template/carrack.png";
            else if(amount==400000)return "images/template/galleon.png";
        }else{
            if(amount==15000)return "images/template/lad.png";
            else if(amount==45000)return "images/template/landlubber.png";
            else if(amount==135000)return "images/template/oldsalt.png";
            else if(amount==400000)return "images/template/seadog.png";
            else if(amount==10000)return "images/template/lad.png";
            else if(amount==30000)return "images/template/landlubber.png";
            else if(amount==90000)return "images/template/oldsalt.png";
            else if(amount==270000)return "images/template/seadog.png";
        }
    },
    async stake(days, price, type) {
      const memo = `staking:${type}`;
      if (days && price) {
        await ApiService.buy(
          {
            from: localStorage.getItem("wax_user"),
            to: process.env.VUE_APP_CONTRACT,
            quantity: `${Number(price).toFixed(8)} DOUB`,
            memo: memo,
          },
          (res) => {
            if (res.processed) {
              toast.success("Transaction processing.");
            }
          },
          (error) => {
            error = ApiService.errorFormat(error);
            toast.error(error);
          }
        );
      } else {
        let error = "Please specify quantity";
        toast.error(error);
      }
    },
  },
};
</script>
<style scoped>
.staking .staking-card_details .large-card {
    background: #457790;
}
</style>